import { isTestKeysBackend } from '@/session';

// Amber "Test mode" pill in the checkout card when the serving backend runs
// test keys, so a publisher previewing the flow can't mistake it for the live
// checkout. Two placements, chosen by CheckoutShell: inside the top toolbar
// row (right end, next to the step indicator) when the step renders one, or —
// for screens with no toolbar like the plan picker — positioned over the
// shell's top padding so it reads as chrome mirroring the close button, not
// as content. The page-level pill from sandboxMode.ts carries the exit action
// and stays handoff-only. Live backends never report test keys, so real
// visitors never see it.
export function SandboxBanner({ floating = false }: { floating?: boolean }) {
  if (!isTestKeysBackend()) {
    return null;
  }
  const pill = (
    <div class="sm-sandbox-banner" role="status">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M7 2v2h1v14a4 4 0 0 0 4 4 4 4 0 0 0 4-4V4h1V2H7zm3 14c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm2-4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-5h-4V4h4v3z" />
      </svg>
      <span>Test mode</span>
    </div>
  );
  return floating ? <div class="sm-sandbox-row">{pill}</div> : pill;
}
